export default {
  'apiRunnerSplitPane.request': 'Request Editor',
  'apiRunnerSplitPane.response': 'Response',
  'apiRunnerSplitPane.vertical': 'Split Vertically',
  'apiRunnerSplitPane.horizontal': 'Split Horizontally',
  'apiRunnerSplitPane.none': 'No Split',
};
